import * as React from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { EstimateApi, GetEstimateGetResponse } from "api/api";

export function ThankYouPage() {
  const { id } = useParams();

  const initialState: GetEstimateGetResponse = {
    contractor: { name: "", phone: "", email: "", address: { street: "", city: "", state: "", zipcode: "" } },
    contactInformation: { name: "", phone: "", preferredContactMethod: "", email: "" },
    worksite: { street: "", city: "", state: "", zipcode: "" },
    submittedEstimate: {
      id: "", friendlyId: "XXXXX", totalPriceLow: 0, totalPriceHigh: 0,
      segments: [{ description: "", gateDescriptions: [], linearFeet: 0 }],
    },
  };

  const [estimate, setEstimate] = React.useState<GetEstimateGetResponse>(initialState);

  React.useEffect(() => {
    EstimateApi.getEstimate(id!).then((d) => setEstimate(d));
  }, [id]);

  return (
    <div>
      {/* Hero */}
      <div className="bg-primary text-white py-5 text-center">
        <span className="badge bg-secondary text-dark text-uppercase mb-3" style={{ letterSpacing: "0.7px" }}>
          Estimate Submitted
        </span>
        <h1 className="display-4 fw-800 mb-2">Thank you!</h1>
        <p className="lead text-white-50">We'll contact you to schedule a free onsite visit.</p>
      </div>

      {/* Summary cards */}
      <div className="px-4 px-lg-5 py-4">
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="ds-card-accent shadow-sm mb-3">
              <CardBody>
                <div className="ds-label mb-1">Worksite</div>
                <address className="mb-0 text-muted small">
                  {estimate.worksite.street}<br />
                  {estimate.worksite.city}, {estimate.worksite.state}, {estimate.worksite.zipcode}
                </address>
              </CardBody>
            </Card>

            <Card className="ds-card-accent shadow-sm mb-3">
              <CardBody>
                <div className="ds-label mb-1">Contact Information</div>
                <p className="mb-0 text-muted small">
                  {estimate.contactInformation.name}<br />
                  {estimate.contactInformation.phone}<br />
                  {estimate.contactInformation.email}<br />
                  Preferred contact: {estimate.contactInformation.preferredContactMethod}
                </p>
              </CardBody>
            </Card>

            <Card className="ds-card-accent shadow-sm mb-3">
              <CardBody>
                <div className="ds-label mb-2">Fence Details</div>
                <ul className="list-unstyled small text-muted mb-2">
                  {estimate.submittedEstimate.segments.map((x, index) => (
                    <li key={index}>
                      {x.linearFeet.toLocaleString("en-us")} LFT {x.description}
                      {x.gateDescriptions.length > 0 && (
                        <ul className="list-unstyled ms-3">
                          {x.gateDescriptions.map((g, idx) => (
                            <li key={idx}>— {g}</li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
                <div className="fw-800 fs-5 text-primary">
                  ${estimate.submittedEstimate.totalPriceLow.toLocaleString("en-us")} –{" "}
                  ${estimate.submittedEstimate.totalPriceHigh.toLocaleString("en-us")}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}
